var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogDayComments" }, [
    _c("div", { staticClass: "modal-card", staticStyle: { width: "520px" } }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("הערה ליום " + _vm._s(_vm.displayDate)),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "b-field",
            { attrs: { label: "הערת היום" } },
            [
              _c("b-input", {
                attrs: {
                  type: "textarea",
                  rows: "5",
                  loading: _vm.isLoading,
                  placeholder: "הערה לאדמין עבור יום זה",
                },
                model: {
                  value: _vm.comments,
                  callback: function ($$v) {
                    _vm.comments = $$v
                  },
                  expression: "comments",
                },
              }),
            ],
            1
          ),
          _c("p", { staticClass: "hint" }, [
            _vm._v("שמירה של הערה ריקה תמחק את ההערה מהיום."),
          ]),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isSaving,
              disabled: _vm.isLoading,
              type: "is-primary",
              label: "שמור",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isSaving, label: "ביטול" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }